import { render, staticRenderFns } from "./player-bank-account-form.vue?vue&type=template&id=9d5056d0&"
import script from "./player-bank-account-form.vue?vue&type=script&lang=js&"
export * from "./player-bank-account-form.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports